import { Box, Flex } from '@chakra-ui/layout'

export function FilterSection() {
  return (
    <Box
      boxSizing="border-box"
      minWidth="0px"
      minHeight="0px"
      gridColumnEnd={{
        base: 'span 12',
        notebook: 'span 4',
      }}
    >
      <Flex
        marginTop={{
          base: '16px',
          notebook: '24px',
        }}
        marginBottom={{
          notebook: '24px',
        }}
        height={{
          base: 'auto',
          notebook: '100%',
        }}
        alignItems="center"
      >
        <Flex width="100%"></Flex>
      </Flex>
    </Box>
  )
}
